// @flow
import GuardDashboard from './GuardDashboard.container';

export default GuardDashboard;
